(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/click-payload.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/click-payload.js'); "use strict";

var clickedElements = new Set();
var _svs$components$adobe = svs.components.adobeTargetPayloadHandler.helpers,
    checkIfDataAttributesExists = _svs$components$adobe.checkIfDataAttributesExists,
    getDataAttributeValue = _svs$components$adobe.getDataAttributeValue;
var logger = svs.core.log.getLogger('components:adobe-target-payload-handler');
var CRM_MBOX = 'crmMbox';
var CRM_METRICS_CLICK = 'crmMetricsClick';

var errorHandlerTarget = function errorHandlerTarget(error) {
  logger.warn("call to target notification for CLICK went wrong ".concat(error.toString()), error);
};

var getValidClickNodes = function getValidClickNodes(element) {
  if (Object.prototype.hasOwnProperty.call(element.dataset, CRM_MBOX)) {
    return false;
  }

  var nodeName = element.nodeName,
      parentElement = element.parentElement;

  if (nodeName === 'BUTTON' || nodeName === 'A') {
    return true;
  } else if (parentElement) {
    return getValidClickNodes(parentElement);
  }

  return false;
};

var sendClickPayload = function sendClickPayload(clickEvent, widgetElement) {
  var targetClick = svs.components.adobeTargetNotification.click;

  if (!clickedElements.has(widgetElement)) {
    if (getValidClickNodes(clickEvent.target)) {
      clickedElements.add(widgetElement);

      if (checkIfDataAttributesExists(widgetElement, [CRM_MBOX, CRM_METRICS_CLICK])) {
        var mbox = getDataAttributeValue(widgetElement, CRM_MBOX);
        var token = getDataAttributeValue(widgetElement, CRM_METRICS_CLICK);
        targetClick({
          mboxName: mbox,
          tokens: [token],
          errorCallback: errorHandlerTarget
        });
      }
    }
  }
};

var setupClickInMbox = function setupClickInMbox(element) {
  element.addEventListener('click', function (event) {
    sendClickPayload(event, element);
  });
};

svs.components.adobeTargetPayloadHandler.setupClickInMbox = setupClickInMbox;
 })(window);